// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar{display:none}@media (min-width: 768px){.sidebar{display:flex;width:33.333333%;flex-shrink:0;flex-grow:0;flex-direction:column;padding-right:1rem;min-width:300px}}.sidebar .sidebar-widget{margin-bottom:1.5rem;--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.sidebar .sidebar-widget:empty{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
